@tailwind base;
@tailwind components;
@tailwind utilities;

/* Scoped reset — applies only to elements inside our modal host. We don't
   want to touch anything on the Shopify page outside #trend-checkout-embed-host.

   `all: revert` rolls every element inside the modal back to the browser's
   user-agent styles, discarding whatever the host theme declared for bare
   elements (uppercase labels, borderless inputs, negative-margin `.grid` …).
   Tailwind utilities and the rules below win over it because their selectors
   are more specific, and postcss.config.js marks all of them `!important`
   so theme rules that are themselves `!important` lose as well. The revert
   itself stays non-important so the components' inline styles keep working.
   Custom properties are untouched by `all`, so Tailwind's `--tw-*` defaults
   survive. SVG content is excluded: any author declaration outranks SVG
   presentation attributes, so the revert would strip fill, stroke and font
   size from the inline card-brand logos. */

#trend-checkout-embed-host,
#trend-checkout-embed-host *:not(svg *) {
  all: revert;
}

#trend-checkout-embed-host,
#trend-checkout-embed-host * {
  box-sizing: border-box;
}

/* trend typography: Inter for copy, Barlow Condensed for the headline. Both
   are loaded from www.trend.at so the modal looks the same on the shop as on
   the portal; if a font file is unavailable the system stack takes over. */
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('https://www.trend.at/fonts/inter/inter-v12-latin-regular-reduced.woff2') format('woff2');
}
@font-face {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('https://www.trend.at/fonts/inter/inter-v12-latin-600-reduced.woff2') format('woff2');
}
@font-face {
  font-family: 'Barlow Condensed';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('https://www.trend.at/fonts/barlow/barlow-condensed-v12-latin-600-reduced.woff2') format('woff2');
}

#trend-checkout-embed-host {
  display: block;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: normal;
  text-transform: none;
  text-align: left;
  color: #222222;
}

#trend-checkout-embed-host button,
#trend-checkout-embed-host input,
#trend-checkout-embed-host select,
#trend-checkout-embed-host textarea {
  font: inherit;
  color: inherit;
  margin: 0;
  /* After `all: revert` a text input carries the user-agent's `inset` border
     style, which draws a 3D edge once `border` gives it a width. Preflight
     would normally set this; it is off, so do it here. */
  border-style: solid;
  /* Inputs carry an intrinsic min width (size=20); inside the 2fr/1fr row
     grids that makes the modal overflow phone viewports unless the host
     theme happens to reset it. Don't rely on the host. */
  min-width: 0;
  max-width: 100%;
}

#trend-checkout-embed-host button {
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0;
}

#trend-checkout-embed-host h1,
#trend-checkout-embed-host h2,
#trend-checkout-embed-host h3,
#trend-checkout-embed-host p,
#trend-checkout-embed-host label,
#trend-checkout-embed-host span {
  margin: 0;
}

#trend-checkout-embed-host a {
  color: inherit;
}

/* Modal scroll container — always render a visible scrollbar so users
   (especially on mobile, where overlay scrollbars hide by default) can tell
   the content is scrollable. `overflow-y: scroll` reserves the gutter even
   when the content fits; the styled track + thumb stay quietly present and
   become obviously functional once content overflows. */
#trend-checkout-embed-host .wco-scroll {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #8E8E8E #F1F1F1;
}
#trend-checkout-embed-host .wco-scroll::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
}
#trend-checkout-embed-host .wco-scroll::-webkit-scrollbar-track {
  background: #F1F1F1;
}
#trend-checkout-embed-host .wco-scroll::-webkit-scrollbar-thumb {
  background: #8E8E8E;
  border: 2px solid #F1F1F1;
  border-radius: 8px;
}
#trend-checkout-embed-host .wco-scroll::-webkit-scrollbar-thumb:hover {
  background: #383838;
}
